function PaperplaneIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 33 33"
      fill="#4079F5"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M19.375 13.944a.479.479 0 00-.048-.656.516.516 0 00-.68-.02l-9.094 7.473-4.802-1.794a1.165 1.165 0 01-.523-.385 1.097 1.097 0 01-.081-1.216 1.15 1.15 0 01.467-.446L24.551 6.114a1.011 1.011 0 011.01.044.96.96 0 01.343.383.922.922 0 01.092.498l-1.75 17.607c-.017.18-.078.354-.177.508-.1.154-.235.283-.395.378a1.237 1.237 0 01-1.078.087l-5.845-2.186-3.669 3.32a.978.978 0 01-1.028.17.94.94 0 01-.414-.34.893.893 0 01-.153-.505V23.47l7.888-9.526z" />
    </svg>
  )
}

export default PaperplaneIcon
